
<template lang="pug">
	b-container.summary-view(fluid)
		BasicHeader(title="Payment Schedule" :subTitle="getContractName" @back="$router.go(-1)")
		b-row.header(align-v="center")
			b-col
				h1.title Payment Schedule
				h6.sub-title {{getContractName}}
		b-row.chart-section
			b-col
				chartsIface.chartCon(:chart='chartDataArray')
</template>

<style lang="scss" scoped>
.entity-summary{
	height: 88%;
}
</style>

<script>
import chartsIface from '@/components/charts/chartsIface';
import BasicHeader from '@/components/general/BasicHeader';

export default {
	name       : 'field-summary',
	components : {
		chartsIface,
    BasicHeader
	},

	computed : {
		chartDataArray() {
			const rdata = [];



			const data={
				label : "label",
				header:20,
				left:0,
				right:12,
				footer:10,
				title:"Payment Schedule",
				barType: 'normal',
				barDims: {
					barWidth  : "7",
					barMargin : "6.4",
					barGroupMargin: ".2",
				},
				chartSelects: {
					chartItems: [
						{
							barGroups: [
								{
									barValues: [500, 600, 800],
									barColors: ['red', 'green', 'blue'],
									barLabel: 'test me'
								},
								{
									barValues: [600, 1500],
									barColors: ['cyan', 'green'],
									barLabel: 'test more'
								}
							],
							selectValue: '2008'
						},
						{
							barGroups: [
								{
									barValues: [523452345234500],
									barColors: ['red'],
									barLabel: 'Oct'
								},
								{
									barValues: [5023452345234520],
									barColors: ['red'],
									barLabel: 'Nov'
								},
								{
									barValues: [5234200],
									barColors: ['red'],
									barLabel: 'Dec'
								},
								{
									barValues: [5040],
									barColors: ['red'],
									barLabel: 'Jan'
								},
								{
									barValues: [5000],
									barColors: ['red'],
									barLabel: 'Feb'
								},
							],
							selectValue: '2009'
						}
					],
					selectLabel: 'Year',
				}

			};
			rdata.push(data);




			return rdata;
		},
		getSelectedContractNum() {
			return this.$store.getters.selectedContract.contractNum.toString();
		},
		getVarietySummaryData() {
			return this.$store.getters.paymentScheduleData;
		},
		getContractName() {
			const name = this.$store.getters.selectedContract.contractName;
			return name;
		},
	},

	methods : {
		GrabUpdatedData() {
			const data = this.$store.getters.paymentScheduleData;
			return data;
		},
	},

	created() {
		this.chartData = this.GrabUpdatedData();
	},

	mounted() {
		this.$nextTick( () => {
			this.initSwiper();
		} );
	},

	// were gonna need to sync our props along with our queries when summary filters

	data : () => ( {
		totalPoundsProducedRes : null,
		insectQueryRes         : null,
		qualityQueryRes        : null,
		PayableYield           : '',
		QualitySummary         : '',
		InsectDamage           : '',
		swiper      : null,
		activeSlide : 0,
		showEmail   : false,
	} ),
};
</script>

<style lang="scss"scoped>
.summary-view {
	background: #f1f9f5;
	color: #026a44;
	font-family: $font-serif;
	height: 88%;
}
.barhart {
	background: #CCFFCC;
}
.header {
	text-align: left;
	height: 25%;
	background: $color;
	.title {
		text-align: left;
		font-weight: bold;
		font-size: 36px;
		font-family: $font-serif;
	}
	.sub-title {
		font-weight: bold;
		font-size: 24px;
		line-height: 100%;
		font-family: $font-serif;
	}
}
.button-section {
	height: 10%;
	text-align: left;
	margin-top: -34px;
	margin-bottom: 20px;
}
.chart-section {
	height: 65%;
}
.btn {
	background: $color-secondary;
	box-shadow: 0px 2px 15px rgba(14, 51, 63, 0.15), 0px 2px 3px rgba(14, 51, 63, 0.15);
	border-radius: 50px;
	width: 135px;
	height: 50px;
	font-family: $font-sans-serif;
	border: none;
	font-size: 17px;
}
.btn:hover,
.btn:active,
.btn:focus {
	background: $color-primary;
}
.dark-btn{
	background: $color-primary
}
.graph-card {
	background: $color;
	border-radius: 20px;
}
.swiper-container {
	height: 95%;
}
.swiper-wrapper {
	height: 85%;
}
.chart-title {
	font-family: $font-sans-serif;
	font-style: normal;
	font-weight: bold;
	font-size: 30px;
	line-height: 30px;
	align-items: center;
	color: #5A726A;
	padding-top: 20px;
}
.chart-sub-title {
	font-family: $font-sans-serif;
	font-style: normal;
	font-weight: bold;
	font-size: 12px;
	line-height: 12px;
	align-items: center;
	color: #5A726A;
	padding-top: 0px;
}
</style>


